module.exports = __webpack_public_path__ + "img/hotel-star-icon.ad6a05f0.svg";